import {
  Tabs,
  TabsContent as RadixTabsContent,
  TabsList as RadixTabsList,
  TabsTrigger as RadixTabsTrigger,
  TabsListProps,
  TabsTriggerProps,
  TabsContentProps,
} from '@radix-ui/react-tabs';
import clsx from 'clsx';
import { FC } from 'react';
import { tabsContent, tabsItem, tabsList } from './tabs.css';

export const TabsRoot = Tabs;

export const TabsList: FC<TabsListProps> = ({ className, ...props }) => (
  <RadixTabsList className={clsx(tabsList, className)} {...props} />
);

export const TabsItem: FC<TabsTriggerProps> = ({ className, ...props }) => (
  <RadixTabsTrigger className={clsx(tabsItem, className)} {...props} />
);

export const TabsContent: FC<TabsContentProps> = ({ className, ...props }) => (
  <RadixTabsContent className={clsx(tabsContent, className)} {...props} />
);
